export default () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3.83811C20 2.06069 18.5516 0.612305 16.7742 0.612305H3.22581C1.44839 0.612305 0 2.06069 0 3.83811V14.1607C0 15.9381 1.44839 17.3865 3.22581 17.3865H16.7742C18.5516 17.3865 20 15.9381 20 14.1607V3.83811ZM9.06452 15.451H3.22581C2.5129 15.451 1.93548 14.8736 1.93548 14.1607V3.83811C1.93548 3.12521 2.5129 2.54779 3.22581 2.54779H9.06452V15.451ZM18.0645 14.1607C18.0645 14.8736 17.4871 15.451 16.7742 15.451H11V2.54779H16.7742C17.4871 2.54779 18.0645 3.12521 18.0645 3.83811V14.1607Z"
      fill="currentColor"
    />
  </svg>
);
